import { Profile } from '@garmin/fitsdk'

interface ProfileMessageEntry {
  messagesKey: string
}

let cachedMap: Map<string, number> | null = null

/** `Profile.messages` is keyed by global mesg number; this is the reverse lookup. */
export function mesgNumByMessagesKey(): Map<string, number> {
  if (cachedMap != null) return cachedMap
  cachedMap = new Map()
  for (const [numStr, entry] of Object.entries(Profile.messages)) {
    cachedMap.set((entry as ProfileMessageEntry).messagesKey, Number(numStr))
  }
  return cachedMap
}
